import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { SignIn } from 'aws-amplify-react';
import { Auth, JS } from 'aws-amplify';

import {
  Heading,
  Body,
  Link,
} from '../../coreui';
import Container from './Container';
import FirstContainer from './FirstContainer';
import SecondContainer from './SecondContainer';

import Form from '../../components/forms/Form';
import Label from '../../components/forms/Label';
import Input from '../../components/forms/Input';
import PasswordInput from '../../components/forms/PasswordInput';
import Questions from './Questions';
import Actions from '../../components/forms/Actions';
import PrimaryButton from '../../components/forms/PrimaryButton';

import trackError from './trackError';

class CustomSignIn extends SignIn {
  constructor(props) {
    super(props);
    this.state = {
      ...this.state,
      submitting: false,
    };
    this._validAuthStates = ['signIn', 'signedOut', 'signedUp'];

    this.updateSubmittingStatus = this.updateSubmittingStatus.bind(this);
    this.handleForgotPasswordClick = this.handleForgotPasswordClick.bind(this);
    this.handleFormSubmit = this.handleFormSubmit.bind(this);
  }

  componentDidUpdate(prevProps) {
    // Check if the authState changed.
    if (prevProps.authState !== this.props.authState) {
      if (this.state.submitting) {
        this.updateSubmittingStatus(false);
      }
    }
  }

  checkContact(user) {
    if (!Auth || typeof Auth.verifiedContact !== 'function') {
      throw new Error('No Auth module found, please ensure @aws-amplify/auth is imported');
    }
    Auth.verifiedContact(user)
      .then((data) => {
        if (!JS.isEmpty(data.verified)) {
          this.changeState('signedIn', user);
        } else {
          this.changeState('confirmSignUp', user);
        }
      });
  }

  updateSubmittingStatus(submitting) {
    this.setState({
      submitting,
    });
  }

  error(err) {
    if (this.state.submitting) {
      this.updateSubmittingStatus(false);
    }
    trackError('SignIn Error', { error: err });
    super.error(err);
  }

  handleForgotPasswordClick(e) {
    e.preventDefault();
    super.changeState('forgotPassword');
  }

  handleFormSubmit(e) {
    e.preventDefault();
    if (!this.state.submitting) {
      this.updateSubmittingStatus(true);
      super.signIn(e);
    }
  }

  showComponent() {
    return (
      <Container>
        <FirstContainer>
          <Heading
            type="H2"
          >
            Sign In.
          </Heading>
          <Body
            type="B1"
          >
            Please enter your email and password below.
          </Body>
          <Form onSubmit={this.handleFormSubmit} >
            <Label
              htmlFor="email"
            >
              E-mail
              <Input
                id="email"
                name="username"
                onChange={(e) => {
                  e.target.value = (e.target.value || '').toLowerCase();
                  this.handleInputChange(e);
                }}
                type="email"
                placeholder="E-mail"
                autoComplete="email"
                required
                data-test="email"
              />
            </Label>
            <Label
              htmlFor="password"
            >
              Password
              <PasswordInput
                id="password"
                name="password"
                onChange={this.handleInputChange}
                autoComplete="current-password"
                required
                data-test="password"
              />
            </Label>
            <Actions>
              <PrimaryButton
                buttonType="submit"
                loading={this.state.submitting}
                disable={this.state.submitting}
                data-test="sign-in-submit"
              >
                Sign In
              </PrimaryButton>
              <Link
                type="L4"
                to="/user/password"
                onClick={this.handleForgotPasswordClick}
              >
                Forgot password?
              </Link>
            </Actions>
          </Form>
          <Questions />
        </FirstContainer>
        <SecondContainer />
      </Container>
    );
  }
}

CustomSignIn.propTypes = {
  ...CustomSignIn.propTypes,
  location: PropTypes.object,
  is403: PropTypes.bool,
};

export default withRouter(CustomSignIn);
